interface WelcomeSlideProps {
  image: string
  title: string
  description: string
  lazy?: boolean
}

export function WelcomeSlide({ image, title, description, lazy = false }: WelcomeSlideProps) {
  // Use 300x300 variant for all devices
  const basePath = image.replace(/\.png$/, '')

  // Generate paths for 300w AVIF and WebP
  const avifSrc = `${basePath}-300w.avif`
  const webpSrc = `${basePath}-300w.webp`

  return (
    <div className="flex flex-col items-center justify-center px-6 py-8">
      <div className="mb-6 w-full max-w-sm">
        <picture>
          <source srcSet={avifSrc} type="image/avif" />
          <source srcSet={webpSrc} type="image/webp" />
          <img
            src={webpSrc}
            alt={title}
            loading={lazy ? "lazy" : "eager"}
            decoding="async"
            width="300"
            height="300"
            className="w-4/5 h-auto rounded-lg mx-auto block"
          />
        </picture>
      </div>
      <h2 className="text-2xl font-bold mb-3 text-center text-[var(--brand-amber)]">
        {title}
      </h2>
      <p className="text-muted-foreground text-center max-w-sm">
        {description}
      </p>
    </div>
  )
}
